import store from '@/store'

import Competition from './Competition'
import CompetitionSeason from './CompetitionSeason'
import Squad from './Squad'
import { status } from './Status'

export default class Match {
  constructor (dataMatch) {
    this.id = dataMatch.id
    this.dayId = dataMatch.dayId

    this.setData(dataMatch)

    this.dateOffsetFirst = 0
    this.dateOffsetSecond = 0
    this.dateOffsetThird = 0
    this.dateOffsetFourth = 0
    this.dateOffsetFifth = 0

    this.competition = null
    if (dataMatch.competition) {
      this.competition = new Competition(dataMatch.competition)
    }
    if (dataMatch.competitionSeason) {
      this.competitionSeason = new CompetitionSeason(dataMatch.competitionSeason)
    }

    this.teamHomeId = dataMatch.teamHomeId
    this.teamAwayId = dataMatch.teamAwayId

    this.squads = { home: [], away: [] }
    if (dataMatch.squads) {
      for (const j in dataMatch.squads) {
        const dataSquad = dataMatch.squads[j]

        if (dataSquad.person) {
          store.commit('Main/Person/load', dataSquad.person)
        }

        if (dataSquad.teamId === dataMatch.teamHomeId) {
          this.squads.home.push(new Squad(dataSquad))
        }

        if (dataSquad.teamId === dataMatch.teamAwayId) {
          this.squads.away.push(new Squad(dataSquad))
        }
      }
    }

    if (dataMatch.userCalendar) {
      this.user = { id: dataMatch.userCalendar.id, login: dataMatch.userCalendar.login }
    }
  }

  setData (dataMatch) {
    this.statusId = dataMatch.statusId

    this.periodThird = dataMatch.periodThird
    this.periodFifth = dataMatch.periodFifth

    this.scoreHome = dataMatch.periodThird ? dataMatch.scoreHomeFourth : dataMatch.scoreHomeSecond
    this.scoreAway = dataMatch.periodThird ? dataMatch.scoreAwayFourth : dataMatch.scoreAwaySecond
    this.scoreHomeFirst = dataMatch.scoreHomeFirst
    this.scoreAwayFirst = dataMatch.scoreAwayFirst
    this.scoreHomeSecond = dataMatch.scoreHomeSecond != null && dataMatch.scoreHomeFirst != null ? dataMatch.scoreHomeSecond - dataMatch.scoreHomeFirst : null
    this.scoreAwaySecond = dataMatch.scoreAwaySecond != null && dataMatch.scoreAwayFirst != null ? dataMatch.scoreAwaySecond - dataMatch.scoreAwayFirst : null
    this.scoreHomeFourth = dataMatch.scoreHomeFourth != null && dataMatch.scoreHomeSecond != null ? dataMatch.scoreHomeFourth - dataMatch.scoreHomeSecond : null
    this.scoreAwayFourth = dataMatch.scoreAwayFourth != null && dataMatch.scoreAwaySecond != null ? dataMatch.scoreAwayFourth - dataMatch.scoreAwaySecond : null
    this.scoreHomeFifth = dataMatch.scoreHomeFifth
    this.scoreAwayFifth = dataMatch.scoreAwayFifth

    this.possessionHome = dataMatch.possessionHome
    this.possessionAway = dataMatch.possessionAway
    this.shotInHome = dataMatch.shotInHome
    this.shotInAway = dataMatch.shotInAway
    this.shotOutHome = dataMatch.shotOutHome
    this.shotOutAway = dataMatch.shotOutAway
    this.freekickHome = dataMatch.freekickHome
    this.freekickAway = dataMatch.freekickAway
    this.cornerHome = dataMatch.cornerHome
    this.cornerAway = dataMatch.cornerAway
    this.offsideHome = dataMatch.offsideHome
    this.offsideAway = dataMatch.offsideAway
    this.foulHome = dataMatch.foulHome
    this.foulAway = dataMatch.foulAway

    this.dateStartFirst = dataMatch.dateStartFirst ? new Date(dataMatch.dateStartFirst) : null
    this.dateStartSecond = dataMatch.dateStartSecond ? new Date(dataMatch.dateStartSecond) : null
    this.dateStartThird = dataMatch.dateStartThird ? new Date(dataMatch.dateStartThird) : null
    this.dateStartFourth = dataMatch.dateStartFourth ? new Date(dataMatch.dateStartFourth) : null
    this.dateStartFifth = dataMatch.dateStartFifth ? new Date(dataMatch.dateStartFifth) : null

    this.dateEndFirst = dataMatch.dateEndFirst ? new Date(dataMatch.dateEndFirst) : null
    this.dateEndSecond = dataMatch.dateEndSecond ? new Date(dataMatch.dateEndSecond) : null
    this.dateEndThird = dataMatch.dateEndThird ? new Date(dataMatch.dateEndThird) : null
    this.dateEndFourth = dataMatch.dateEndFourth ? new Date(dataMatch.dateEndFourth) : null
    this.dateEndFifth = dataMatch.dateEndFifth ? new Date(dataMatch.dateEndFifth) : null

    this.dateEnd = dataMatch.dateEnd ? new Date(dataMatch.dateEnd) : null
    this.dateDeferred = dataMatch.dateDeferred ? new Date(dataMatch.dateDeferred) : null
    this.dateStopped = dataMatch.dateStopped ? new Date(dataMatch.dateStopped) : null
    this.dateSuspended = dataMatch.dateSuspended ? new Date(dataMatch.dateSuspended) : null
    this.dateCanceled = dataMatch.dateCanceled ? new Date(dataMatch.dateCanceled) : null
  }

  homeAway (team) {
    return team.id === this.teamHomeId ? 'home' : (team.id === this.teamAwayId ? 'away' : '')
  }

  awayHome (team) {
    return team.id === this.teamHomeId ? 'away' : (team.id === this.teamAwayId ? 'home' : '')
  }

  dateStartByStatus (statusId) {
    switch (statusId) {
      case 7: return this.dateStartFirst
      case 8: return this.dateStartSecond
      case 9: return this.dateStartThird
      case 10: return this.dateStartFourth
      case 11: return this.dateStartFifth
      default: return null
    }
  }

  dateStartOffsetByStatus (statusId) {
    switch (statusId) {
      case 7: return this.dateStartFirstOffset
      case 8: return this.dateStartSecondOffset
      case 9: return this.dateStartThirdOffset
      case 10: return this.dateStartFourthOffset
      case 11: return this.dateStartFifthOffset
      default: return null
    }
  }

  dateEndByStatus (statusId) {
    switch (statusId) {
      case 7: return this.dateEndFirst
      case 8: return this.dateEndSecond
      case 9: return this.dateEndThird
      case 10: return this.dateEndFourth
      case 11: return this.dateEndFifth
      default: return null
    }
  }

  offset (action) {
    let value = 0
    if (action.date) {
      let items = []
      switch (action.statusId) {
        case 7:
          items = this.dateOffsetsFirst
          break
        case 8:
          items = this.dateOffsetsSecond
          break
        case 9:
          items = this.dateOffsetsThird
          break
        case 10:
          items = this.dateOffsetsFourth
          break
        case 11:
          items = this.dateOffsetsFifth
          break
      }

      const time = action.date.getTime()
      if (items.length > 0) {
        for (const i in items) {
          const item = items[i]
          if (time > item.date) {
            value = (value + item.value)
          } else {
            break
          }
        }
      }
    }

    return value
  }

  get dateStart () { return this.dateStartByStatus(this.statusId) }
  get dateStartOffset () { return this.dateStartOffsetByStatus(this.statusId) }

  get dateStartFirstOffset () { return this.dateStartFirst ? new Date(this.dateStartFirst.getTime() - this.dateOffsetFirst) : null }
  get dateStartSecondOffset () { return this.dateStartSecond ? new Date(this.dateStartSecond.getTime() - this.dateOffsetSecond) : null }
  get dateStartThirdOffset () { return this.dateStartThird ? new Date(this.dateStartThird.getTime() - this.dateOffsetThird) : null }
  get dateStartFourthOffset () { return this.dateStartFourth ? new Date(this.dateStartFourth.getTime() - this.dateOffsetFourth) : null }
  get dateStartFifthOffset () { return this.dateStartFifth ? new Date(this.dateStartFifth.getTime() - this.dateOffsetFifth) : null }

  get penaltyShootOut () { return status.penaltyShootOut(this.statusId) }
}
